import * as THREE from 'three';
import {
  TEST_PANEL,
  testPanelAt,
  testPanelButtons,
  type TestPanelAction,
} from '../engine/test-panel.js';
import { Button } from './panel.js';

/**
 * The test panel drawn: one Button per testPanelButtons entry, in a group the caller hangs on the
 * lectern's. Pressing a button calls `onPress` with its action; the view's own label does nothing.
 */
export class TestPanel {
  readonly group = new THREE.Group();
  /** Every button, for freeing; `pressable` is the ones that do something. */
  readonly buttons: Button[] = [];
  readonly pressable: Button[] = [];

  constructor(
    input: Parameters<typeof testPanelButtons>[0],
    onPress: (action: TestPanelAction) => void,
  ) {
    for (const spec of testPanelButtons(input)) {
      const pressed = spec.action.kind !== 'none';
      const button = new Button(spec.label, () => onPress(spec.action), {
        width: spec.width,
        height: TEST_PANEL.rowHeight,
        kind: pressed ? 'primary' : 'muted',
      });
      button.mesh.position.set(spec.x, spec.y, 0.002);
      this.group.add(button.mesh);
      this.buttons.push(button);
      if (pressed) this.pressable.push(button);
    }
    const at = testPanelAt();
    this.group.position.set(at.x, at.y, 0);
    this.group.name = 'test-panel';
  }

  dispose(): void {
    for (const button of this.buttons) button.dispose();
    this.group.removeFromParent();
  }
}
